import React from 'react';
import DigitalTwinAssessment from '../components/DigitalTwinAssessment';

const DigitalTwinPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12">
      <div className="container mx-auto px-4">
        <DigitalTwinAssessment />
      </div>
    </div>
  );
};

export default DigitalTwinPage;